import { doc, setDoc } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import config from "@poseidon/utils/config";

export const setAction = async (entity, entityId, entityKey, state, userId) => {
  try {
    await setDoc(
      doc(db, entity, entityId, config.SaltCollection._action, entityKey),
      {
        actionFor: "admin",
        state,
        updatedBy: {
          user: doc(db, "dealers", userId),
          userType: "dealer",
        },
      },
      { merge: true }
    );
  } catch (error) {
    return Error(error);
  }
};
export const updateBoatHin = async (hin, boatId, userId) => {
  await setDoc(
    doc(db, "boats", boatId),
    {
      hin,
      lastUpdatedBy: doc(db, "dealers", userId),
    },
    {
      merge: true,
    }
  );
};
